import React from 'react';

import { IdentityProvider } from '../../context';

import { NewWillProvider } from './new-will-provider';

export function NewWillComposer() {
  return (
    <IdentityProvider>
      <NewWillProvider />
    </IdentityProvider>
  );
}
